import { motion } from 'framer-motion';
import { SectionHeader } from '@/components/dashboard/MetricCard';
import BrokerChat from '@/components/dashboard/BrokerChat';
import { useAccess } from '@/components/dashboard/access';
import { useSiteLang } from '@/components/site/SiteLang';

const T = {
  es: {
    title: 'Asistente IA',
    broker: 'Tu asistente personal con información del club, tus comisiones y tu red',
    member: 'Tu asistente personal con información del club y de tu membresía',
  },
  en: {
    title: 'AI assistant',
    broker: 'Your personal assistant for club information, your commissions and your network',
    member: 'Your personal assistant for club information and your membership',
  },
};

// Solo miembros de pago y equipo (ruta protegida con AccessGate en App.js)
export default function DashboardChat() {
  const { isBroker } = useAccess();
  const { lang } = useSiteLang();
  const t = T[lang] || T.es;
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="space-y-6"
      data-testid="dashboard-chat"
    >
      <SectionHeader
        title={t.title}
        subtitle={isBroker ? t.broker : t.member}
      />
      <BrokerChat />
    </motion.div>
  );
}
